<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">Súmula TCE/MA</h4>
      </v-alert>
      <v-form :disabled="!userHasPermission()" v-model="valid" lazy-validation ref="form">
        <v-container>

          <v-row>
            <v-col md="2" cols="12">
              <v-text-field
                label="Número da Súmula"
                required
                v-model="sumula.numero"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                type="number"
                label="Nº Processo"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="sumula.numeroProcesso"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                label="Ano do Processo"
                type="number"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="sumula.anoProcesso"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                label="Sessão Plenária"
                type="date"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="sumula.dataSessao"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                label="Data no Diário"
                type="date"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="sumula.dataDiario"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="textArea"
                label="Enunciado"
                v-model="sumula.enunciado"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="textArea"
                label="Fundamentação Legal"
                v-model="sumula.fundamentacao"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="precedentes"
                label="Precedentes"
                v-model="sumula.precedentes"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row style="margin-top: 2%">
            <v-col cols="12" md="2">Palavras-Chave</v-col>
            <v-col cols="12" md="8" style="margin-top: -1.2%">
              <v-combobox
                v-model="sumula.palavrasChave"
                chips
                clearable
                label="Palavras-Chave"
                multiple
                prepend-icon="mdi-filter-variant"
                solo
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(item)"
                  >
                    <strong>{{ item }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn
                color="primary"
                small
                depressed
                @click="salvar()"
                :disabled="!userHasPermission()"
              >
                Salvar
              </v-btn>
              <span></span>
              <v-btn
                style="margin-left: 2%"
                color="primary"
                small
                depressed
                to="/sumulas"
                >Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </app-layout>
</template>

<script>
import sumulaService from "@/service/SumulaService";
export default {
  data() {
    return {
      valid: false,
      sumula: {
        enunciado: null,
        numeroProcesso: null,
        anoProcesso: null,
        dataSessao: null,
        dataDiario: null,
        fundamentacao: null,
        precedentes: null,
        palavrasChave: null,
        numero: null
      },
    };
  },
  methods: {
    salvar() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        sumulaService
          .salvar(this.sumula)
          .then((result) => {
            (this.sumula = result), alert("Documento Salvo!"), this.sair();
          })
          .catch((err) => console.error(err.message));
      } else {
        alert("Informe os campos Obrigatórios!");
      }
    },
    remove(item) {
      this.sumula.palavrasChave.splice(
        this.sumula.palavrasChave.indexOf(item),
        1
      );
      this.sumula.palavrasChave = [...this.sumula.palavrasChave];
    },
    sair() {
      this.$router.push("/sumulas");
    },
  },
  mounted() {
    if (this.$route.params.id != 0) {
      sumulaService
        .buscar(this.$route.params.id)
        .then(
          (res) => ((this.sumula = res), (this.tipoPessoa = res.tipoPessoa))
        );
    }
  },
};
</script>

<style>
</style>